import { featurePermissionsList, PERMISSION_TYPE } from '../../../../constants/featurePermissionsConstant';

export const getFeatureName = (featureId: string) => {
	const permissionList = Object.values(featurePermissionsList);
	const feature: any = (permissionList ?? []).find((f) => f.featureId === featureId);

	if (!feature || feature.isNoLongerUsed) {
		return undefined;
	}

	return feature.displayLabel;
};

export const getBulkPermissionUpdate = (featureId: string, featurePermission: any[]) => {
	const permissionType = PERMISSION_TYPE[featureId as keyof typeof PERMISSION_TYPE];

	if (!permissionType || !featurePermission) {
		return undefined;
	}

	return featurePermission.filter((permission: any) => permission.type === permissionType);
};
